// extracted by mini-css-extract-plugin
module.exports = {"main-container":"Profile_main-container__1Iwu6"};